import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import type { AppStatus } from '../../types/dynamics.types';

const STATUS_CONFIG: Record<AppStatus, { label: string; cssClass: string }> = {
  queued: { label: 'Queued', cssClass: 'status-queued' },
  building: { label: 'Building', cssClass: 'status-building' },
  built: { label: 'Built', cssClass: 'status-built' },
  deploying: { label: 'Deploying', cssClass: 'status-deploying' },
  deployed: { label: 'Deployed', cssClass: 'status-deployed' },
  failed: { label: 'Failed', cssClass: 'status-failed' },
};

@Component({
  selector: 'app-status-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<span [class]="config().cssClass">{{ config().label }}</span>`,
  styleUrl: './status-badge.component.less',
})
export class StatusBadgeComponent {
  protected readonly config = computed(() => STATUS_CONFIG[this.status()]);
  public readonly status = input.required<AppStatus>();
}
